import { render, staticRenderFns } from "./TrainingHRM.vue?vue&type=template&id=5a30e5a3&"
import script from "./TrainingHRM.vue?vue&type=script&lang=js&"
export * from "./TrainingHRM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports